import { Box, Typography } from '@wishket/design-system';

import Avatar from '../Avatar/Avatar';
import NewLandingTitle from '../NewLandingTitle/NewLandingTitle';

import { Icon } from '@/shared/Components';
import { PATH } from '@/shared/constants';

const RecommendedCollectionsHeader = () => {
  const editor = {
    src: `${PATH.MEDIA_YOZM_IMAGE}/manager_daechung.png`,
    name: '장대청',
  };
  return (
    <Box className="flex items-center gap-4 desktop:gap-5">
      <Box className="desktop:hidden">
        <Avatar src={editor.src} variant="gradient" size="sm" />
      </Box>
      <Box className="hidden desktop:block">
        <Avatar src={editor.src} variant="gradient" size="md" />
      </Box>
      <Box className="flex flex-col gap-1">
        <NewLandingTitle title="요즘 에디터의 추천 컬렉션" />
        <Box className="flex items-center gap-0.5">
          <Icon name="by" />
          <Typography variant="body1" className="font-regular text-w-gray-400">
            {editor.name}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RecommendedCollectionsHeader;
